import React from 'react';

import { useNavigate } from 'react-router-dom';

import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';
import useReactQuery from '@/hooks/common/useReactQuery';
import { type ParentWithStudents } from '@/interfaces/parent';

const OrganizationMembershipRegistrationCompleteForm: React.FC = () => {
  const navigate = useNavigate();
  const { useQuery } = useReactQuery();

  const { refetch: refetchMe } = useQuery<ParentWithStudents>({
    queryKey: ['me'],
    url: '/api/school/parents/me',
    enabled: false,
  });

  const handleMypage = () => {
    // tanstack-queryのキャッシュ更新
    void refetchMe();

    navigate('/mypage/profile');
  };

  return (
    <JumbotronPanel
      panelHeaderTitle={pageTitles.mypageOrganizationMembershipsComplete}
    >
      <JumbotronTitle>生徒情報の登録が完了しました</JumbotronTitle>
      <JumbotronDescription>
        「マイページ」ボタンより
        <br />
        アカウント情報をご確認ください。
      </JumbotronDescription>
      <JumbotronButtonArea>
        <Button onClick={handleMypage} size="m" color="primary">
          マイページへ
        </Button>
      </JumbotronButtonArea>
    </JumbotronPanel>
  );
};

export default OrganizationMembershipRegistrationCompleteForm;
